import revive_payload_client_4sVQNw7RlN from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import api_manager_hlaEdD4Avf from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/api-manager.ts";
import toastification_xLadjaQwvu from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/toastification.ts";
import vuetify_7h9QAQEssH from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/vuetify.ts";
import tabler_icons_plugin_shbTszC3ON from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/tabler-icons-plugin.ts";
import stringify_safe_j49DDZaMfp from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/stringify-safe.ts";
import string_utils_gESRsMJlCL from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/string-utils.ts";
import debugModePlugin_lksrVgRVBs from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/debugModePlugin.ts";
import filepond_cmb58IAqJr from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/filepond.ts";
import drag_handle_Fa1a2Qpit7 from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/drag-handle.ts";
import vue_cron_editor_vuetify_ylieyrH07C from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/vue-cron-editor-vuetify.ts";
import vue_ctk_date_time_picker_lHSOOVpMD7 from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/vue-ctk-date-time-picker.ts";
import permission_checker_Rwp47x407b from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/plugins/permission-checker.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  api_manager_hlaEdD4Avf,
  toastification_xLadjaQwvu,
  vuetify_7h9QAQEssH,
  tabler_icons_plugin_shbTszC3ON,
  stringify_safe_j49DDZaMfp,
  string_utils_gESRsMJlCL,
  debugModePlugin_lksrVgRVBs,
  filepond_cmb58IAqJr,
  drag_handle_Fa1a2Qpit7,
  vue_cron_editor_vuetify_ylieyrH07C,
  vue_ctk_date_time_picker_lHSOOVpMD7,
  permission_checker_Rwp47x407b
]